import React from 'react';
import EDBox from '../EDBox/EDBox';
import EDSkeleton from '../Skeleton/EDSkeleton';

interface ISkeletonListProps {
  /** Number of skeleton rows to render */
  rows?: number;
  /** Height of each row in px */
  rowHeight?: number;
  /** Gap between rows in px */
  gap?: number;
}

/**
 * Reusable list-style skeleton loader.
 * Drop in wherever a list is loading — routines, menus, search results, etc.
 */
const SkeletonList: React.FC<ISkeletonListProps> = ({
  rows = 4,
  rowHeight = 40,
  gap = 12,
}) => (
  <EDBox
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: `${gap}px`,
      width: 'auto',
      height: 'auto',
      justifyContent: 'start',
      p: 1,
    }}
  >
    {Array.from({ length: rows }).map((_, i) => (
      <EDSkeleton
        key={i}
        variant="rectangular"
        height={rowHeight}
        width={i === rows - 1 ? '60%' : '100%'} // last row shorter for visual variety
        animation="pulse"
        sx={{ borderRadius: 1 }}
      />
    ))}
  </EDBox>
);

export default SkeletonList;
